import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UnAuthenticationError } from '@digibricks/core';
import { AxiosApi } from '@digibricks/plugin-axios';
export var CLASS_ANNOUNCEMENT_API = 'CLASS_ANNOUNCEMENT_API';
export var ClassAnnouncementApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ClassAnnouncementApi, _AxiosApi);

  var _super = _createSuper(ClassAnnouncementApi);

  function ClassAnnouncementApi(instance) {
    _classCallCheck(this, ClassAnnouncementApi);

    return _super.call(this, 'classes', instance);
  }

  _createClass(ClassAnnouncementApi, [{
    key: "path",
    value: function path(classId, id) {
      return "".concat(this.url, "/").concat(encodeURIComponent(classId), "/announcements").concat(id ? "/".concat(encodeURIComponent(id)) : '');
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(operation) {
        var body, _error$response, _error$response$data, _error$response2, _error$response3, raw, message, failure;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return operation();

              case 3:
                body = _context.sent.data;
                return _context.abrupt("return", Result.ok(body.data));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                raw = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message;
                message = Array.isArray(raw) ? raw.join(', ') : raw || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);
                failure = new Error(message || 'Could not load announcements.');
                Object.assign(failure, {
                  status: _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status
                });
                return _context.abrupt("return", (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response3 = _context.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 401 ? new UnAuthenticationError(failure.message) : Result.fail(failure));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "list",
    value: function list(classId, nextToken) {
      var _this = this;

      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      return this.request(function () {
        return _this.axios.get(_this.path(classId), {
          params: {
            limit: limit,
            nextToken: nextToken || undefined
          }
        });
      });
    }
  }, {
    key: "get",
    value: function get(classId, id) {
      var _this2 = this;

      return this.request(function () {
        return _this2.axios.get(_this2.path(classId, id));
      });
    }
  }, {
    key: "create",
    value: function create(classId, input) {
      var _this3 = this;

      return this.request(function () {
        return _this3.axios.post(_this3.path(classId), input);
      });
    }
  }, {
    key: "update",
    value: function update(classId, id, input) {
      var _this4 = this;

      return this.request(function () {
        return _this4.axios.patch(_this4.path(classId, id), input);
      });
    }
  }, {
    key: "pin",
    value: function pin(classId, id, pinned, version) {
      var _this5 = this;

      return this.request(function () {
        return _this5.axios.patch("".concat(_this5.path(classId, id), "/pin"), {
          pinned: pinned,
          version: version
        });
      });
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(classId, id, version) {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.request(function () {
                  return _this6.axios["delete"](_this6.path(classId, id), {
                    params: {
                      version: version
                    }
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete(_x2, _x3, _x4) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return ClassAnnouncementApi;
}(AxiosApi);